"use strict";

exports.__esModule = true;
exports.NATIVE_CODE_OPERATORS = exports.IN_OPERATORS = exports.CONDITION_TEXT_OPERATORS = void 0;
var IN_OPERATORS = exports.IN_OPERATORS = [{
  value: "IN",
  displayName: "In"
}, {
  value: "NOT_IN",
  displayName: "Not in"
}];
var CONDITION_TEXT_OPERATORS = exports.CONDITION_TEXT_OPERATORS = [{
  value: "CONTAINING",
  displayName: "Containing"
}, {
  value: "NOT_CONTAINING",
  displayName: "Not containing"
}];
var NATIVE_CODE_OPERATORS = exports.NATIVE_CODE_OPERATORS = [{
  value: "HAVING",
  displayName: "Having"
}, {
  value: "NOT_HAVING",
  displayName: "Not having"
}];